export default __webpack_public_path__ + "static/media/034-pedestrian-2.fa091360.png";